import { internalLogger } from '../../../../../interface/v1/clientOsLogger';
import { LoggedInHandleParamsType } from '../types';
import AbstractLoggedInHandler from './AbstractLoggedInHandler';
import multiChannelEventManager, {
  MultiChannelEvents
} from '../../../../../services/session/MultiChannelEvents';

export default class NotifyIsLoggedInHandler extends AbstractLoggedInHandler {
  public async handle(params: LoggedInHandleParamsType): Promise<void> {
    const { services } = params;
    const isLoggedIn = services.sessionService.isLoggedIn();

    if (isLoggedIn) {
      internalLogger?.debug?.d2({
        className: 'NotifyIsLoggedInHandler',
        methodName: 'handle',
        message: 'Publishing shellWebUserLogedInEventName event.',
        parameters: { isLoggedIn }
      });
      multiChannelEventManager.publish(MultiChannelEvents.USER_LOGGED_IN, {
        isLoggedIn: true
      });
    }

    return super.handle(params);
  }
}
